import React from "react";
import useSeverityAsPriority, {
  SeverityFieldsEnum,
} from "../../General/useSeverityAsPriority";
import { kebabCase } from "lodash-es";
import { normalizeNumbers } from "@SeemplicityDev/shared";
import { useAnimateInView } from "./useAnimateInView";

type ResourceCategory =
  | "Machine"
  | "Code"
  | "Cloud"
  | "Container Image"
  | "Runtime Container"
  | "Serverless"
  | "Web"
  | "User"
  | "Other";

interface ResourcesPageProps {
  data?: {
    categories: {
      name: ResourceCategory;
      resources_count: number;
      severe_count: {
        severity: number;
        count: number;
      };
    }[];
  };
}

const ResourcesPage: React.FC<ResourcesPageProps> = ({ data }) => {
  const { ref, animateClassNames } = useAnimateInView();

  const { getSeverityField } = useSeverityAsPriority();

  return (
    <div className={`eoy-page resources-page ${animateClassNames}`} ref={ref}>
      <h2 className="page-title">
        Resource categories with associated critical findings
      </h2>
      <div className={`categories-container has-${data?.categories.length}`}>
        {!!data &&
          data.categories.map((category) => {
            return (
              <div
                className="category-container"
                key={category.name}
                style={{
                  backgroundColor: getSeverityField(
                    category.severe_count.severity,
                    SeverityFieldsEnum.COLOR
                  ),
                }}
              >
                <div className="category-title">
                  <i
                    className={`seem-icon-resource-${kebabCase(category.name)}`}
                  />
                  <span>{category.name}</span>
                </div>
                <div className="data-container">
                  <span className="resources-count">
                    {normalizeNumbers(category.resources_count)} Resources
                  </span>
                  <span
                    className="severe-count"
                    style={{
                      color: getSeverityField(
                        category.severe_count.severity,
                        SeverityFieldsEnum.COLOR
                      ),
                    }}
                  >
                    {normalizeNumbers(category.severe_count.count)} Findings
                  </span>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default ResourcesPage;
